import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazz.bet/bzfront/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
